<template>
  <div class="page-container">
    <div class="page-content">
      <facial-reader ref="reader" :on-read="validCode" :processing="isProcessing" />

      <!-- Error message -->
      <div class="error-overlay" v-if="showError">
        <div class="error-box">
          <img src="@/assets/images/icon/caution-sign.png" class="icon" alt="">
          <p>{{ errorMessage }}</p>
          <button type="button" class="btn-retry" @click="clearError">
            <i class="bx bx-refresh"></i>
            Tentar novamente
          </button>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <router-link class="text" :to="{ name: routeHomeName }">
        <i class="icon bx bx-home"></i>
        Home
      </router-link>
    </div>

    <!-- Volumes Modal - Opens directly after facial recognition -->
    <volumes-modal
      ref="volumesModal"
      :participant="currentParticipant"
      :items="currentItems"
      @close="onVolumesClose"
      @register-item="openRegisterModal"
      @return-item="openReturnModal"
    />

    <!-- Register Modal -->
    <register-modal
      ref="registerModal"
      :participant="currentParticipant"
      :locations="locations"
      :item-types="itemTypes"
      @registered="onItemRegistered"
      @close="onRegisterClose"
    />

    <!-- Return Modal -->
    <return-modal
      ref="returnModal"
      :item="selectedItem"
      :participant="currentParticipant"
      @returned="onItemReturned"
      @close="onReturnClose"
    />
  </div>
</template>

<script>
import { STORAGE_PAGE_INDEX } from '@/modules/storage/routes'
import FacialReader from '@/modules/check-in/pages/facial/facial-reader'
import VolumesModal from '@/modules/storage/pages/index/volumes-modal'
import RegisterModal from '@/modules/storage/pages/index/register-modal'
import ReturnModal from '@/modules/storage/pages/index/return-modal'
import { mapState, mapActions } from 'vuex'
import { STORAGE_MODULE } from '@/modules/storage'

export default {
  name: 'storage-facial',
  components: {
    FacialReader: FacialReader,
    VolumesModal: VolumesModal,
    RegisterModal: RegisterModal,
    ReturnModal: ReturnModal
  },
  data: function () {
    return {
      routeHomeName: STORAGE_PAGE_INDEX,
      showError: false,
      errorMessage: '',
      selectedItem: null,
      isProcessing: false
    }
  },
  computed: {
    ...mapState(STORAGE_MODULE, {
      currentParticipant: function (state) { return state.currentParticipant },
      currentItems: function (state) { return state.currentItems },
      locations: function (state) { return state.locations },
      itemTypes: function (state) { return state.itemTypes }
    })
  },
  methods: {
    ...mapActions(STORAGE_MODULE, [
      'loadLocations',
      'loadItemTypes',
      'scanParticipantByFacial',
      'loadParticipantItems',
      'clearCurrentParticipant'
    ]),
    validCode: function (data) {
      var self = this
      self.showError = false
      self.errorMessage = ''
      self.isProcessing = true

      return self.scanParticipantByFacial(data.photo)
        .then(function (result) {
          self.isProcessing = false
          // Open volumes modal directly
          self.$refs.volumesModal.open()
        })
        .catch(function (error) {
          self.isProcessing = false
          self.errorMessage = error.message || 'Participante nao encontrado'
          self.showError = true
        })
    },
    clearError: function () {
      this.showError = false
      this.errorMessage = ''
    },
    onVolumesClose: function () {
      // Clear participant and go back to scan mode
      this.clearCurrentParticipant()
    },
    openRegisterModal: function () {
      this.$refs.registerModal.open()
    },
    openReturnModal: function (item) {
      this.selectedItem = item
      this.$refs.returnModal.open()
    },
    onItemRegistered: function (item) {
      var self = this
      // Reload participant items
      if (self.currentParticipant) {
        self.loadParticipantItems(self.currentParticipant.id)
      }
      self.$refs.registerModal.close()
    },
    onItemReturned: function (item) {
      var self = this
      // Reload participant items
      if (self.currentParticipant) {
        self.loadParticipantItems(self.currentParticipant.id)
      }
      self.$refs.returnModal.close()
    },
    onRegisterClose: function () {
      // Nothing to do
    },
    onReturnClose: function () {
      this.selectedItem = null
    }
  },
  mounted: function () {
    this.loadLocations()
    this.loadItemTypes()
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #E5E5E5;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  padding: 0;
  position: relative;
}

.page-footer {
  background-color: #292F42;
  display: grid;
  place-items: center;
  min-height: 64px;

  .text {
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 300;

    .icon {
      font-size: 32px;
    }
  }
}

.error-overlay {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  padding: 16px;

  .error-box {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    max-width: 400px;
    margin: 0 auto;

    img.icon {
      width: 48px;
      margin-bottom: 12px;
    }

    p {
      color: #E3414B;
      font-size: 14px;
      margin-bottom: 16px;
    }

    .btn-retry {
      display: flex;
      width: 100%;
      border: none;
      border-radius: 8px;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      padding: 12px;
      background-color: #292F42;
      color: #fff;
      cursor: pointer;
      gap: 8px;

      i {
        font-size: 18px;
      }
    }
  }
}
</style>
